import { KDDatHangService } from './../../../kinh-doanh/kd-dat-hang/kd-dat-hang-service/kd-dat-hang.service';
import { FunctionPublic } from './../../../dung-chung/__function/common_function';
import { DeNghiMuaHangService } from '../../../mua-hang/de-nghi-mua-hang/de-nghi-mua-hang-service/de-nghi-mua-hang.service';
import { select } from '@ngrx/store';
import {Component,
		OnInit,
		ElementRef,
		ViewChildren,
		ViewChild,
		ChangeDetectionStrategy,
		ChangeDetectorRef,
		Inject,
		HostListener,
		Optional
	}
from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { KhoDeNghiXuatKhoPageService } from '../kho-de-nghi-xuat-kho-page-service/kho-de-nghi-xuat-kho-page.service';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';

import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { CONFIGURATION, DEFAULT, KhoDeNghiXuatKhoPage, KhoDeNghiXuatKhoPageChiTiet} from '../kho-de-nghi-xuat-kho-page-model/kho-de-nghi-xuat-kho-page.model';

import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import moment from 'moment';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { ChiTietSoLuongTonPageComponent } from '../chi-tiet-so-luong-ton-page/chi-tiet-so-luong-ton-page.component';
import { LichSuXuatKhoComponent } from '../lich-su-xuat-kho/lich-su-xuat-kho.component';
import { KDDatHangEditComponent } from '../../../kinh-doanh/kd-dat-hang/kd-dat-hang-edit/kd-dat-hang-edit.component';
import { YeuCauXuatKhanEditDialogComponent } from '../../../ke-hoach/yeu-cau-xuat-khan/yeu-cau-xuat-khan-edit-dialog/yeu-cau-xuat-khan-edit-dialog.component';

@Component({
	selector: 'm-kho-de-nghi-xuat-kho-page-detail',
	templateUrl: './kho-de-nghi-xuat-kho-page-detail.component.html',
	styleUrls: ['../kho-de-nghi-xuat-kho-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class KhoDeNghiXuatKhoPageDetailComponent implements OnInit {
	//#region Config
	CONFIG: CommonConFig;
	//#endregion Config

	//#region Các trường focus cho các tag trong form
	@ViewChildren('focusLyDo') focusLyDo;
	/* Trigger menu hiển thị cột cho danh sách */
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;
	//#endregion Các trường focus cho các tag trong form

	//#region Column Table
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: 'select',
			displayName: 'Chọn',
			alwaysChecked: false,
			isShow: true
        },
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MAHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TENHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QUYCACH',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
        },
		{
			stt: 5,
			name: "SOPHIEUDHB",
			displayName: "Số phiếu ĐHB",
			alwaysChecked: true,
			isShow: true,
		},
		{
            stt: 6,
            name: 'SOLUONG',
            displayName: 'Số lượng',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 7,
            name: 'DONVITINH',
            displayName: 'Đơn vị tính',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SOLUONGTHUCXUAT',
            displayName: 'SL thực xuất',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'TTDX',
            displayName: 'Tổng tồn được xuất',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'TTKDX',
            displayName: 'Tổng tồn không được xuất',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'TDKXTN',
            displayName: 'Tổng dự kiến xuất trong ngày',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'BPDN',
            displayName: 'Bộ phận đề nghị',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'BPSD',
            displayName: 'Bộ phận sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'NewBPSD',
            displayName: 'Bộ phận sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'MUCDICHSUDUNG',
            displayName: 'Mục đích sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SOLO',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SOMAY',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SXSM',
            displayName: 'Số xe/số mẻ',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 9,
            name: 'NGAYCAN',
            displayName: 'Ngày cần',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'MAKH',
            displayName: 'Mã KH',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'TENKH',
            displayName: 'Tên KH',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'OBJTHCP',
            displayName: 'Đối tượng THCP',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'NSX',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'HSD',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'MATHUNG',
            displayName: 'Mã thùng (TP)',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'NGUOIDUYET',
            displayName: 'Người duyệt',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'NGAYDUYET',
            displayName: 'Ngày duyệt',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'KETQUA',
            displayName: 'Kết quả',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'LYDO',
            displayName: 'Ghi chú kết quả duyệt',
            alwaysChecked: false,
			isShow: true
		},
	];
	sumColums: string[] = ['#','SOLUONG', 'SOLUONGTHUCXUAT'];

	//#endregion Column Table

	//#region Mat Select
	/* Mat select search cho khach hang */
	listListKH : any[] = [];
	selectListKH : string = '';
	filteredListKH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListKHFilterCtrl: string = '';
	haveElementListKH: boolean = false;
	/* ------------------------------------------------------------------ */
	/* Mat select search cho hàng hóa */
	listId_HH : any[] = [];
	selectId_HH : string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	/* ------------------------------------------------------------------ */
	//#endregion Mat Select

	//#region Khai báo biến
	/* Giá trị đầu tiên cho dropdown quyết định nhập hàng - Form QC kiểm tra*/
	processImport: boolean = true;		// Có đang chạy import
	/* ------------------------------------------------------------------ */

	/* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<KhoDeNghiXuatKhoPageChiTiet>(true, []);
	/* ------------------------------------------------------------------ */

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* Extend field:  */
	previousIndex: number; 			// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                 // Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;		// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false;    // Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedTTHV: number[] = []	// Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = true;   // Loading khi mở dialog
	canEdit: boolean = false;		// Dialog có thể chỉnh sửa không?
	/* ------------------------------------------------------------------ */

	/* Các Sub form trên dialog:  */
	KhoDeNghiXuatKhoPageForm: FormGroup;				//Form phiếu đề nghị
	hasFormErrors: boolean = false;

	KhoDeNghiXuatKhoPageSubForm: FormGroup;				//Form phiếu đề nghị
	hasSubFormErrors: boolean = false;

	ImportHHForm: FormGroup;
	/* ------------------------------------------------------------------ */

	/* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	KhoDeNghiXuatKhoPageItem: KhoDeNghiXuatKhoPage;

	/* Danh sách tạm chi tiết hàng hóa của phiếu đề nghị dùng để cập nhập trên lưới  */
	tmpChiTietKhoDeNghiXuatKhoPage: KhoDeNghiXuatKhoPageChiTiet[] = [];

	/* Danh sách tình trạng phiếu */
	Tinhtrang = [
		{
			id: 1,
			name: 'Đang soạn thảo',
			value: 'KHOPDNXK_LUUNHAP',
		},
		{
			id: 2,
			name: 'Chờ duyệt',
			value: 'KHOPDNXK_CHODUYET',
		},
		{
			id: 3,
			name: 'Bị trả lại',
			value: 'KHOPDNXK_BITRALAI',
		},
		{
			id: 4,
			name: 'Hoàn tất',
			value: 'KHOPDNXK_HOANTAT',
		},
		{
			id: 5,
			name: 'Đã hủy',
			value: 'KHOPDNXK_DAHUY',
		},
		{
			id: 6,
			name: 'Chờ xuất kho',
			value: 'KHOPDNXK_CHOXUATKHO',
		},
	];
	//#endregion Khai báo biến

	//#region Phím tắt nhanh
	openDialog: boolean = true;
	activatedRoute: ActivatedRoute;
	@HostListener('body:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.keyCode == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.keycode && !this.openDialog) {
			this.back();
		}
	}
	//#endregion Phím tắt nhanh

	// ROLES
	TAO_DNXKHAN = "1310";
	SHOW_BUTTON_CREATE_DNXKHAN = new BehaviorSubject < boolean > (false);
	LIST_ROLES_USER: [] = [];

	// .. Hàm set page/dialog
	isPage = new BehaviorSubject<boolean>(true);

	//#region Constructor
	constructor(
		@Optional() public dialogRef: MatDialogRef<KhoDeNghiXuatKhoPageDetailComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
		private KhoDeNghiXuatKhoPageService: KhoDeNghiXuatKhoPageService,
		private DungChungService: DungChungService,
		public dialog: MatDialog,
		private KhoDeNghiXuatKhoPageFB: FormBuilder,
		private KhoDeNghiXuatKhoPageSubFB: FormBuilder,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef,
		private route: ActivatedRoute,
		private router: Router,
		private subheaderService: SubheaderService,
		private deNghiMuaHangService: DeNghiMuaHangService,
		private serviceKH: KDDatHangService
	) {
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		this.LIST_ROLES_USER = user.roles;
	}
	//#endregion Constructor

	//#region Load Data
	ngOnInit() {
		// Set chức năng button
		this.SHOW_BUTTON_CREATE_DNXKHAN.next(this.isTrueButton(this.TAO_DNXKHAN));

		this.viewLoading = true;
		this.openDialog = false;
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();

		/*Get data from list when open dialog */
		this.KhoDeNghiXuatKhoPageItem = new KhoDeNghiXuatKhoPage();
		this.KhoDeNghiXuatKhoPageItem.clear();

		/*Load all dropdown and create form */
		this.createForm();
		/*Handel escape event in dialog*/

		// .. Điều hướng dialog
		if (this.data && this.data.Id){
			this.bindingDataDetail(this.data.Id);
			this.isPage.next(false);
		}
		else // .. Điều hướng page
		{
			this.route.params.subscribe(params => {
				const id = +params.id;
				if (id && id > 0) {
					//this.viewLoading = true;
					let breadcrumbs = [{ title: 'Kho' }, { title: 'Đề nghị xuất kho', page: '/de-nghi-xuat-kho' }, { title: 'Chi tiết', page: '/de-nghi-xuat-kho/chi-tiet/'+id }];
					this.subheaderService.setBreadcrumbs(breadcrumbs);
					this.bindingDataDetail(id);
				} else {
					this.router.navigateByUrl('/404');
				}
			});
		}

		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
		this.changeDetect.detectChanges();
	}

	ngAfterViewInit() {
		this.changeDetect.detectChanges();
	}
	//#endregion Load Data

	//#region Tạo form
	createForm(){
		const item = this.KhoDeNghiXuatKhoPageItem;

		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		var idPhongBan = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		this.tokenStorage.getCoCauId().subscribe(a => {idPhongBan = ''+a;});

		/*Group các Form */
		this.KhoDeNghiXuatKhoPageForm = this.KhoDeNghiXuatKhoPageFB.group({
			SOPHIEU: [!(item.Sophieu == undefined || item.Sophieu == '') ? item.Sophieu : '', Validators.required],
			NGAYLAP: [!(item.Ngaytao == undefined || item.Ngaytao == '') ? item.Ngaytao : this.strDate(''), Validators.required],
			NGUOILAP: [item.Nguoitao > 0 ? item.TenNguoitao : tenNguoiLap],
			TRANGTHAI: [(item.Tinhtrang == '')? this.Tinhtrang[0].value: item.Tinhtrang],
			DESCTRANGTHAI: [(item.DescTinhTrang == '')?  this.Tinhtrang[0].name: item.DescTinhTrang],
			LOAIPHIEU: [(!item.TenLoaiPhieu)? '' : ''+item.TenLoaiPhieu],
            GHICHU: [(!item.Ghichu)? '' : item.Ghichu],
			LYDOXUAT: [(!item.Lydocode)? CONFIGURATION.OTHER_REASONS.value : item.Lydo],
			LYDOKHAC: [(!item.Lydocode)? item.Lydo : ''],
			CHUNGTUKEMTHEO: [(item.ChungTuKemTheo)? item.ChungTuKemTheo : false],
			TENSOCHUNGTU: [(item.TenSoChungTu)? item.TenSoChungTu : ''],
			SUPPLIER_CODE: [(item.SupplierCode)? item.SupplierCode : ''],
			SUPPLIER_NAME: [(item.SupplierName)? item.SupplierName : ''],
			RECEIVER_NAME: [(item.Receiver)? item.Receiver : ''],
			ADDRESS_RECEIVE_PRODUCT: [(item.AddressReceiveProduct)? item.AddressReceiveProduct : ''],
		});

		const form = this.KhoDeNghiXuatKhoPageForm.controls;

		/*Disable các trường dữ liệu không thay đổi */
		form["SOPHIEU"].disable();
		form["NGUOILAP"].disable();
		form["NGAYLAP"].disable();
		form["DESCTRANGTHAI"].disable();
		form["LOAIPHIEU"].disable();
		form["GHICHU"].disable();
		form["LYDOXUAT"].disable();
		form["LYDOKHAC"].disable();
		form["CHUNGTUKEMTHEO"].disable();
		form["TENSOCHUNGTU"].disable();
		form["SUPPLIER_CODE"].disable();
		form["SUPPLIER_NAME"].disable();
		form["RECEIVER_NAME"].disable();
		form["ADDRESS_RECEIVE_PRODUCT"].disable();

		this.tmpChiTietKhoDeNghiXuatKhoPage = item.ChiTiet;
		this.tmpChiTietKhoDeNghiXuatKhoPage.forEach(x => {
			x.XuLy.PhieuDeNghi = x.IdDn;
			x.XuLy.PhieuDeNghiCT = x.IdCtdn;
			x.XuLy.TenNguoiDuyet = x.XuLy.TenNguoiDuyet? x.XuLy.TenNguoiDuyet : '';
			x.XuLy.NgayDuyetDate = x.XuLy.NgayDuyet? new Date(x.XuLy.NgayDuyet): null;
			x.XuLy.LyDo = x.XuLy.LyDo? x.XuLy.LyDo : '';
		})
		this.tmpChiTietKhoDeNghiXuatKhoPage = [...this.tmpChiTietKhoDeNghiXuatKhoPage];

		// this.selectListKH = this.KhoDeNghiXuatKhoPageForm.controls["MAKH"].value;

	}
	//#endregion Tạo form

	//#region Tiêu đề page
	getTitle(): string {
		return `CHI TIẾT PHIẾU ĐỀ NGHỊ XUẤT KHO `;
	}
	//#endregion Tiêu đề page
	getColSpan(){
		return this.displayedColumns.indexOf("SOLUONG")
	}
	getTotalNumber(){
		let total = 0;
		this.tmpChiTietKhoDeNghiXuatKhoPage.forEach(element => {
		   total += Number(element.SLThucXuat)
		});
		return total;
	}
	getTotalNumber2(){
		let total = 0;
		this.tmpChiTietKhoDeNghiXuatKhoPage.forEach(element => {
			total += Number(element.SoLuongQuiDoi)
		});
		return total;
	}
	//#region Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng
    showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];

		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	//#endregion Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng

	//#region Lấy phòng ban
	ListKH(select: boolean = false){

		this.DungChungService.listPB().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.viewLoading = false;
				this.listListKH = res.data;
				this.filteredListKH.next(this.listListKH.slice());
				this.changeDetect.detectChanges();

			};
		});
	}

	filterListKH() {
		if (!this.listListKH) {
			return;
		}
		// get the search keyword
		let search = this.ListKHFilterCtrl;
		if (!search) {
			this.filteredListKH.next(this.listListKH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListKH.next(
			this.listListKH.filter(ts =>
				ts.MaKH.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	//#endregion Lấy phòng ban

	//#region Hỗ trợ format dữ liệu form, validate
	changeValueOfForm(controlName: string, event: any){
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = this.KhoDeNghiXuatKhoPageSubForm.controls[controlName].value.replace(/,/g, "");
			if(!this.KhoDeNghiXuatKhoPageSubForm.controls['KHOILUONG'].invalid){
				this.KhoDeNghiXuatKhoPageSubForm.controls[controlName].setValue(
					this.f_number(tmpValue)
				);
			}
			if(tmpValue.indexOf('.') == 0 && tmpValue.length == 1){
				tmpValue = 0;
			}
			this.KhoDeNghiXuatKhoPageSubForm.controls[controlName].setValue(
				this.f_number(tmpValue)
			);
		}
		else{
			this.KhoDeNghiXuatKhoPageSubForm.controls[controlName].setValue(''+event.target.value);
		}
	}

	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {

		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == '.'){
					count += 1;
				}
			}
		}
		else{
			for(let i = 0; i < event.length; i++){
				if(event[i] == '.'){
					count += 1;
				}
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);

		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}

	formatNumber(item: string){
		if(item == '' || item == null || item == undefined)	return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
	}

	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}

	f_currency_V2(value: string): any {
		if(value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}

	// f_currency_VND(value: string): any {
	// 	if (value == null || value == undefined) return '0,00';
	// 	return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	// }

	getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}

	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}

	dateToDDMMYYYY(__data: any){
		let __date = new Date(__data);
		return ("0" + __date.getDate()).slice(-2)+"/"+("0" + (__date.getMonth() + 1)).slice(-2)+"/"+__date.getFullYear();
	}

	// formatComparenumber(number: string){
	// 	return +number.replace(/,/g, "");
	// }
	//#endregion Hỗ trợ format dữ liệu form , validate

	//#region Chuyển trạng thái phiếu
	checkGuiDuyet(checked: boolean = false){
		if(checked){
			this.KhoDeNghiXuatKhoPageForm.controls['DESCTRANGTHAI'].setValue(this.Tinhtrang[1].name);
			this.KhoDeNghiXuatKhoPageForm.controls['TRANGTHAI'].setValue(this.Tinhtrang[1].value);
		}else{
			this.KhoDeNghiXuatKhoPageForm.controls['DESCTRANGTHAI'].setValue(this.Tinhtrang[0].name);
			this.KhoDeNghiXuatKhoPageForm.controls['TRANGTHAI'].setValue(this.Tinhtrang[0].value);
		}
	}
	//#endregion Chuyển trạng thái phiếu

	//#region Thoát form
	back(){
		if (this.isPage.value)
			this.router.navigateByUrl('de-nghi-xuat-kho', { relativeTo: this.activatedRoute });
		else
			this.dialogRef.close();
	}
	//#endregion Thoát form

	//#region Xư lý duyệt, không duyệt
	onSubmit(action: boolean) { // true là duyệt false là không duyệt
		this.hasFormErrors = false;
		const controls = this.KhoDeNghiXuatKhoPageSubForm.controls;
		/** check form */
		if(action == false){
			this.KhoDeNghiXuatKhoPageSubForm.controls['LYDO'].setValidators([Validators.compose([Validators.required])]);
			this.KhoDeNghiXuatKhoPageSubForm.controls['LYDO'].updateValueAndValidity();

			if (this.KhoDeNghiXuatKhoPageSubForm.invalid) {
				Object.keys(controls).forEach(controlName =>
					controls[controlName].markAsTouched()
				);
				setTimeout(() => this.focusLyDo.first.nativeElement.focus(), 500);
				this.hasFormErrors = true;
				return;
			}
		}
		const _sophieu = this.KhoDeNghiXuatKhoPageItem.Sophieu;
		if(action){
			this.KhoDeNghiXuatKhoPageSubForm.controls['LYDO'].clearValidators();
			this.KhoDeNghiXuatKhoPageSubForm.controls['LYDO'].updateValueAndValidity();
			const dialogRef = this.layoutUtilsService.POP03(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				this.KhoDeNghiXuatKhoPageItem.Lydokhongduyet = controls['LYDO'].value;
				this.KhoDeNghiXuatKhoPageService.accept(this.KhoDeNghiXuatKhoPageItem).subscribe(res =>{
					const message = 'Phiếu đề nghị xuất kho ' +_sophieu+' cập nhật thành công.';
					this.layoutUtilsService.showInfo(message);
					this.KhoDeNghiXuatKhoPageForm.reset();
					this.tmpChiTietKhoDeNghiXuatKhoPage = [];
					this.tmpChiTietKhoDeNghiXuatKhoPage = [...this.tmpChiTietKhoDeNghiXuatKhoPage];
					this.isChange = true;
					this.saveAddedTTHV.push(res.data.IdDn);
					this.back();
				});
			});

		}else{
			const dialogRef = this.layoutUtilsService.POP02(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				this.KhoDeNghiXuatKhoPageItem.Lydokhongduyet = this.KhoDeNghiXuatKhoPageSubForm.controls['LYDO'].value;
				this.KhoDeNghiXuatKhoPageService.reject(this.KhoDeNghiXuatKhoPageItem).subscribe(res =>{
					const message = 'Phiếu đề nghị xuất kho ' +_sophieu+' cập nhật thành công.';
					this.layoutUtilsService.showInfo(message);
					this.KhoDeNghiXuatKhoPageForm.reset();
					this.tmpChiTietKhoDeNghiXuatKhoPage = [];
					this.tmpChiTietKhoDeNghiXuatKhoPage = [...this.tmpChiTietKhoDeNghiXuatKhoPage];
					this.isChange = true;
					this.saveAddedTTHV.push(res.data.IdDn);
					this.back();
				});
			});


		}
	}
	//#endregion Xư lý duyệt, không duyệt

	//#region Reset Form
	resetSubForm(){
		this.KhoDeNghiXuatKhoPageSubForm.reset();
		this.KhoDeNghiXuatKhoPageSubForm.controls['SOLUONG'].setValue("0.00");
		this.KhoDeNghiXuatKhoPageSubForm.controls['SLTON'].setValue("0.00");
		this.KhoDeNghiXuatKhoPageSubForm.controls['NGAYCAN'].setValue(new Date());
	}
	//#endregion Reset Form

	getItemCssClassByStatus(status: any): string {
		switch (status) {
			case "KHODNXK_DUYETCT":
				return this.CONFIG.COLOR_STATE._HoanTatCase;
			case "KHODNXK_KHONGDUYETCT":
				return this.CONFIG.COLOR_STATE._HuyCase;
		}
	}

	lichSuXuatKho(item: KhoDeNghiXuatKhoPageChiTiet){
		this.openDialog = true;
		const dialogRef = this.dialog.open(LichSuXuatKhoComponent, {
			data: {
				IdCtdn : item.IdCtdn,
				Ma_Ten_HH : item.MaHH + " - " + item.TenHH
			},
			maxHeight: '90vh',
			width: '75vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.openDialog = true;
			setTimeout(() => {
				this.openDialog = false;
			}, 500);
		});
	}

	xuLyDauVaoCTSLT(form: boolean = true, item: KhoDeNghiXuatKhoPageChiTiet = null){
		if(form){
			if(!this.selectId_HH){
				this.layoutUtilsService.showErorr("Vui lòng chọn hàng hoá trước khi xem chi tiết số lượng tồn");
				return;
			}
			var Id_HH = Number(this.selectId_HH);
			var index = this.listId_HH.findIndex(x => x.Id_HH == Id_HH);
			if(index > -1){
				this.chiTietSoLuongTon(Id_HH, this.listId_HH[index].MaHH + " - " + this.listId_HH[index].TenHH );
			}
		}else{
			if(item != null){
				this.chiTietSoLuongTon(item.IdHh, item.MaHH + " - " + item.TenHH);
			}
		}
	}

	chiTietSoLuongTon(IdHH: number, Ma_Ten_HH: string){
		this.openDialog = true;
		const dialogRef = this.dialog.open(ChiTietSoLuongTonPageComponent, {
			data: {
				IdHH : IdHH,
				Ma_Ten_HH : Ma_Ten_HH
			},
			maxHeight: '90vh',
			width: '75vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.openDialog = true;
			setTimeout(() => {
				this.openDialog = false;
			}, 500);
		});
	}

	f_number(item: any = "0.00000"){
		return FunctionPublic.F_NUMBER_DYNAMIC(item, FunctionPublic.MAX_POINT);
	}

	ShowButtonPassKhan(){
		return (this.SHOW_BUTTON_CREATE_DNXKHAN || this.isCreatedBill())
			&& this.tmpChiTietKhoDeNghiXuatKhoPage.filter(x => (x.TongDuKienXuatTrongNgay > x.TongTonDuocXuat) && (x.TongTonKhongDuocXuat > 0)).length > 0;
	}

	isCreatedBill(){
		let idUserCreated = this.KhoDeNghiXuatKhoPageItem.Nguoitao;
		var idLoginData = 0;
		this.tokenStorage.getIDUser().subscribe(t => { idLoginData = +t; });
		return idUserCreated == idLoginData;
	}

	isCreatedPassKhan(){
		//
		var tmp = this.tmpChiTietKhoDeNghiXuatKhoPage.filter(x => (x.TongDuKienXuatTrongNgay > x.TongTonDuocXuat) && (x.TongTonKhongDuocXuat > 0));
		var tmpData = [];
		tmp.forEach(x => {
			var e = {
				IdDn : x.IdDn,
				IdCtDn : x.IdCtdn,
				IdHH : x.IdHh,
				KeHoachId : x.NguonPhatSinhId,
				SLCanXuat : x.TongDuKienXuatTrongNgay - x.TongTonDuocXuat
			}
			tmpData.push(e);
		});

		this.router.navigate(['yeu-cau-xuat-khan/them-tu-de-nghi-xuat-kho/'+this.KhoDeNghiXuatKhoPageItem.IdDn,{}], {
			state: {
				IsDeNghiXuatKho: true,
				data : tmpData
			}
		})
	}

	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: KhoDeNghiXuatKhoPageChiTiet){
		if(event.target.value == "")
		{
			event.target.value =  this.f_number(min);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if(event.target.value.toString() == item[columnName].toString())
		{
			event.target.value =  this.f_number(item[columnName]);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");

			if(isNaN(tmpValue)) tmpValue = min;

			if(Number(tmpValue) < min) tmpValue = min;

			if(!item[columnName]){
				item[columnName] = tmpValue;
			}

			item[columnName] = tmpValue;

			event.target.value = this.f_number(tmpValue);
		}
		else{
			item[columnName] = min;
		}

		this.changeDetect.detectChanges();
	}

	keyUpInputNumberVND(event){
		FunctionPublic.preventAlphaV2(event);
	}

	checkSoLuongError(){
		return this.tmpChiTietKhoDeNghiXuatKhoPage.length != this.tmpChiTietKhoDeNghiXuatKhoPage.filter(x => x.Soluong > 0).length;
	}

	haveRecordDNXKFromKHSX(){
		return this.tmpChiTietKhoDeNghiXuatKhoPage.filter(x => x.NguonPhatSinhType =='NPSDNXK_KHSX').length > 0;
	}

	updateDetailDNXKFromKHSX(){
		var data = new KhoDeNghiXuatKhoPage();
		data.clear();
		data = this.KhoDeNghiXuatKhoPageItem;
		data.ChiTiet = this.tmpChiTietKhoDeNghiXuatKhoPage;
		this.KhoDeNghiXuatKhoPageService.editDetail(data).subscribe(res => {
			if(res && res.status == 1){
				this.layoutUtilsService.showInfo("Cập nhật số lượng đề nghị xuất kho thành công");
				this.updateDataRecord();
			}else{
				this.layoutUtilsService.showErorr("Lỗi cập nhật dữ liệu chi tiết đề nghị xuất kho");
			}
		});
	}

	updateDataRecord(){
		this.KhoDeNghiXuatKhoPageService.detail(this.KhoDeNghiXuatKhoPageItem.IdDn).subscribe(res => {
			if(res && res.status == 1){
				this.KhoDeNghiXuatKhoPageItem = res.data;
				if(this.KhoDeNghiXuatKhoPageForm != null){
					this.tmpChiTietKhoDeNghiXuatKhoPage = [...this.KhoDeNghiXuatKhoPageItem.ChiTiet];
					this.changeDetect.detectChanges();
				}
			}
		});
	}

	open_dialog_detail_dhb(__iddn: number) {
		this.openDialog = true;
		this.serviceKH.detailOrder(__iddn).subscribe((res) => {
			if (res.status == 1) {
				const dialogRef = this.dialog.open(
					KDDatHangEditComponent,
					{
						data: {
							data: res.data,
							chi_tiet: true,
							model: res.data.BusinessModel
						},
						maxHeight: "90vh",
						width: "90vw",
					}
				);
				dialogRef.afterClosed().subscribe((res) => {
					setTimeout(() => {
						this.openDialog = false;
					}, 50);
				});
			} else {
				this.openDialog = false;
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}

	//#region Function check quyền
	isTrueButton(ROLENUMBER: string) {
		if (this.LIST_ROLES_USER.findIndex((x) => x == ROLENUMBER) > -1) {
			return true;
		}
		return false;
	}
	//#endregion Function check quy

	openDialogPassKhan(_id: number){
		const dialogRef = this.dialog.open(YeuCauXuatKhanEditDialogComponent, {
			data: {
				id : _id,
				data : []
			},
			maxHeight: '90vh',
			width: '90vw'
		});

		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
		});
	}

	isDisplayBtnPassKhan(_row){
		return (this.SHOW_BUTTON_CREATE_DNXKHAN || this.isCreatedBill())
				&& (_row.TongDuKienXuatTrongNgay > _row.TongTonDuocXuat)
				&& (_row.TongTonKhongDuocXuat > 0)
				&& (_row.Soluong > 0);
	}

	sendPassKhan(_row){
		var e = {
			IdDn : _row.IdDn,
			IdCtDn : _row.IdCtdn,
			IdHH : _row.IdHh,
			KeHoachId : _row.NguonPhatSinhId,
			SLCanXuat : _row.TongDuKienXuatTrongNgay - _row.TongTonDuocXuat
		}
		this.router.navigate(['yeu-cau-xuat-khan/them-tu-de-nghi-xuat-kho/'+this.KhoDeNghiXuatKhoPageItem.IdDn,{}], {
			state: {
				IsDeNghiXuatKho: true,
				data : [e]
			}
		})
	}

	get_date_nhap_kho(){
		var date = new Date(this.KhoDeNghiXuatKhoPageForm.controls['NGAYLAP'].value);
		return "Ngày "+("0" + date.getDate().toString()).slice(-2)+ " tháng "+ ("0" + (date.getMonth() + 1).toString()).slice(-2) + " năm "+ date.getFullYear(); 
	}
	sum_so_luong(){
		return this.tmpChiTietKhoDeNghiXuatKhoPage.length > 0 ? this.tmpChiTietKhoDeNghiXuatKhoPage.map(x => Number(x.SoLuongQuiDoi)).reduce((a, b) => a + b) : 0;
	}
	// ' Hàm format date sang định dạng text dd/MM/yyyy hh:mm '
	strDate(d){
		if (!d) return '';
		var date  = new Date(d);
		var day   = ("00" + date.getDate()).slice(-2);
  		var month = ("00" + (date.getMonth() + 1)).slice(-2);
  		var year  = date.getFullYear();
		var hours = ("00" + date.getHours()).slice(-2);
		var minutes = ("00" + date.getMinutes()).slice(-2);
		return day + "/" + month + "/" + year + " " + hours + ":" + minutes;
	}
	// .. Binding data chi tiết
	bindingDataDetail(id){
		this.KhoDeNghiXuatKhoPageService.detail(id).subscribe(res => {
			if(!res || res.status == 0 || res.data.Tinhtrang == "KHOPDNXK_DAXOA"){
				this.router.navigateByUrl('/404');
			}
			else if(res && res.status == 1){
				const form = this.KhoDeNghiXuatKhoPageForm;
				this.KhoDeNghiXuatKhoPageItem = res.data;
				const item = this.KhoDeNghiXuatKhoPageItem;
				if(form != null){
					this.KhoDeNghiXuatKhoPageItem.IdDn = id;
					form.controls['SOPHIEU'].setValue(item.Sophieu);
					form.controls['NGAYLAP'].setValue(this.strDate(item.Ngaytao));
					form.controls['NGUOILAP'].setValue(item.TenNguoitao);
					form.controls['DESCTRANGTHAI'].setValue(item.DescTinhTrang);
					form.controls['LOAIPHIEU'].setValue(''+item.TenLoaiPhieu);
					form.controls['GHICHU'].setValue(item.Ghichu);
					form.controls['CHUNGTUKEMTHEO'].setValue(item.ChungTuKemTheo);
					form.controls['TENSOCHUNGTU'].setValue(item.TenSoChungTu);
					form.controls['SUPPLIER_CODE'].setValue(item.SupplierCode);
					form.controls['SUPPLIER_NAME'].setValue(item.SupplierName);
					form.controls['RECEIVER_NAME'].setValue(item.Receiver);
					form.controls['ADDRESS_RECEIVE_PRODUCT'].setValue(item.AddressReceiveProduct);
					// .. Xử lý lý do xuất
					if (!item.Lydocode){
						form.controls['LYDOXUAT'].setValue(CONFIGURATION.OTHER_REASONS.value);
						form.controls['LYDOKHAC'].setValue(item.Lydo);
					}
					else 
						form.controls['LYDOXUAT'].setValue(item.Lydo);
					// ...................
					this.KhoDeNghiXuatKhoPageItem.ChiTiet.forEach(x => x.SoMay = x.SoMay ? x.SoMay.split(",").map(x => x.toString().trim()).join(", ") : "")
					this.tmpChiTietKhoDeNghiXuatKhoPage = [...this.KhoDeNghiXuatKhoPageItem.ChiTiet];
					this.changeDetect.detectChanges();
				}
			}
		});
	}
	// .. Nếu loại phiếu 'Xuất trả NCC và TH Khác' và lý do xuất 'Xuất trả NCC'
	toggleReturnTypeAndReasonForReuturnSupplier(){
		const item 	 = this.KhoDeNghiXuatKhoPageItem;
		const type 	 = item.MaLoaiPhieu;
		const reason = item.Lydocode ? item.Lydocode : CONFIGURATION.OTHER_REASONS.key;
		return type == CONFIGURATION.SUPPLIER_RETURN_TYPE && reason == CONFIGURATION.REASON_FOR_SUPPLIER_RETURN;
	}
	// .. Nếu loại phiếu 'Xuất trả NCC và TH Khác' và lý do xuất 'Khác'
	toggleReturnTypeAndAnotherReason(){
		const item 	 = this.KhoDeNghiXuatKhoPageItem;
		const type 	 = item.MaLoaiPhieu;
		const reason = item.Lydocode ? item.Lydocode : CONFIGURATION.OTHER_REASONS.key;
		return type == CONFIGURATION.SUPPLIER_RETURN_TYPE && reason == CONFIGURATION.OTHER_REASONS.key;
	}
	// ..........................
}

